<template>
  <div class="switch-dept">
    <el-dialog
      width="620px"
      title="设置代理人"
      :visible.sync="showDialog"
      :modal="true"
      @close="closeDialog"
    >
      <div class="container" v-loading="loading">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item label="设置代理人" prop="name">
            <el-input
              v-model="ruleForm.name"
              readonly
              placeholder="请选择代理人"
              @focus="treeInputFocus"
            ></el-input>
          </el-form-item>
          <el-form-item label="代理期限" prop="proxyDuration">
            <el-select v-model="ruleForm.proxyDuration" placeholder="请选择">
              <el-option label="即时生效" :value="1"></el-option>
              <el-option label="限时生效" :value="2"></el-option>
              <el-option label="关闭" :value="-1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.proxyDuration == 2" prop="dateRange">
            <el-date-picker
              v-model="ruleForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="confirm" v-throttle>保存</el-button>
      </div>
    </el-dialog>
    <TreeDialogNew
      ref="treeRef"
      :isMultiple="false"
      :isSelectPerson="true"
      :activeList.sync="addApprovalForm.selected"
      :activeUserIds.sync="addApprovalForm.userId"
      :modal="false"
      @saveClose="saveCloseTreeDialog"
    />
  </div>
</template>

<script>
  import TreeDialogNew from '@/components/TreeDialogNew/index';
  import {
    getAgentSettingByUid,
    saveOrUpdateAgentSetting
  } from '@/api/verification.js';
  export default {
    name: 'proxyApprovalSettingDialog',
    components: {
      TreeDialogNew
    },
    data() {
      return {
        loading: false,
        id: '',
        showDialog: false,
        ruleForm: { name: '', proxyDuration: '', dateRange: '' },
        rules: {
          name: [{ required: true, message: '请选择代理人' }],
          proxyDuration: [
            { required: true, message: '请选择代理期限', trigger: 'change' }
          ],
          dateRange: [
            { required: true, message: '请选择代理期限', trigger: 'blur' }
          ]
        },
        addApprovalForm: {
          selected: [],
          userId: []
        },
        pickerOptions: {
          disabledDate(time) {
            // 禁止选择今天之前的日期 今天可以选择
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      };
    },
    methods: {
      closeDialog() {
        this.$refs['ruleForm'].resetFields();
      },
      async getAgentSettingByUid() {
        try {
          const res = await getAgentSettingByUid();
          if (res) {
            let params = {
              name: res.agentName,
              userId: res.agentId,
              proxyDuration: res.agentType
            };
            if (res.agentType == 2) {
              params.dateRange = [
                new Date(res.agentStartTime),
                new Date(res.agentEndTime)
              ];
            }
            this.id = res.id;
            this.ruleForm = { ...params };
          }
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.Sentry.captureException(error);
        }
      },
      saveCloseTreeDialog(treeActiveList) {
        if (treeActiveList.length > 0) {
          this.ruleForm.name = treeActiveList[0].label;
          this.ruleForm.userId = treeActiveList[0].id;
        }
        this.$refs.treeRef.treeIconClose();
      },
      treeInputFocus() {
        this.$refs.treeInputRef?.blur();
        this.$refs.treeRef?.open();
      },
      async open() {
        this.showDialog = true;
        this.loading = true;
        await this.getAgentSettingByUid();
      },
      async confirm() {
        this.$refs['ruleForm'].validate(async (validate) => {
          if (validate) {
            try {
              const params = {
                agentId: this.ruleForm.userId,
                agentType: this.ruleForm.proxyDuration
              };
              if (params.agentType == 2) {
                params.agentStartTime = this.ruleForm.dateRange[0].getTime();
                params.agentEndTime = this.ruleForm.dateRange[1].getTime();
              }
              if (this.id) {
                params.id = this.id;
              }
              await saveOrUpdateAgentSetting(params);
              this.$message.success('设置成功');
              this.showDialog = false;
            } catch (error) {
              this.Sentry.captureException(error);
            }
          }
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  ::v-deep .el-dialog {
    border-radius: 8px 8px 8px 8px;
    .el-dialog__body {
      border-top: 2px solid #f6f6f6;
      padding: 16px 24px !important;
      .el-row {
        margin-bottom: 8px;
      }
    }
  }
  ::v-deep .is-bordered {
    width: 574px !important;
    padding: 12px !important;
    box-sizing: border-box;
    height: auto;
  }
  ::v-deep .el-radio__label {
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 20px;
    vertical-align: middle;
    display: inline-block;
    padding-right: 18px;
  }
  .proxy-approval-setting-dialog {
    max-height: 320px;
    overflow-y: auto;
  }
</style>
